var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"py-2"},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }